<template>
  <el-drawer
    title="模拟用户搜索"
    :before-close="handleClose"
    :visible.sync="dialogVisible"
    direction="ltr"
    custom-class="search-test-drawer"
    ref="drawer"
    :append-to-body="true"
    size="65%"
    :destroy-on-close="true"
  >
    <div class="content">
      <div class="player">
        <video v-if="src" controls autoplay :src="src"></video>
        <div v-else class="player-placeholder">
          选择一条结果后，可在这里试听
        </div>
      </div>

      <el-form :model="search_op" class="search-form" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model.trim="search_op.search_name"
            autocomplete="off"
            placeholder="请输入用户可能搜索的关键词"
            @keyup.enter.native="getList()"
          >
            <el-button
              slot="append"
              type="primary"
              :loading="table_loading"
              @click="getList()"
            >
              搜索
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>

      <div class="summary">
        <span>分词结果：</span>
        <template v-if="jiebaList.length">
          <el-tag
            v-for="word in jiebaList"
            :key="word"
            size="small"
            class="word-tag"
          >
            {{ word }}
          </el-tag>
        </template>
        <span v-else>—</span>
        <span class="total">共 {{ total }} 条结果</span>
      </div>

      <el-table
        :data="tableList"
        height="420"
        v-loading="table_loading"
        empty-text="没有找到匹配的音效"
        style="width: 100%"
      >
        <el-table-column prop="name" label="音效名称" min-width="190" show-overflow-tooltip />
        <el-table-column prop="source_type" label="来源" width="90">
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="sourceType(row) === 'cloud' ? 'success' : 'info'"
            >
              {{ sourceType(row) === 'cloud' ? '云端' : '网络' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="download_times" label="下载次数" width="100" align="right">
          <template slot-scope="{ row }">
            {{ sourceType(row) === 'cloud' && row.download_times !== null
              && row.download_times !== undefined ? row.download_times : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="classify" label="分类" width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" icon="el-icon-video-play" @click="play(row)">
              试听
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_num"
        :page-sizes="[10, 20, 30]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </el-drawer>
</template>

<script>
import apis from "@/api/index"

export default {
  name: "SearchTest",
  data() {
    return {
      dialogVisible: false,
      tableList: [],
      src: "",
      jiebaList: [],
      total: 0,
      page_num: 1,
      page_size: 10,
      search_op: {
        search_name: ""
      },
      table_loading: false
    }
  },
  methods: {
    show(searchName) {
      this.src = ""
      this.search_op.search_name = searchName
      this.dialogVisible = true
      this.getList()
    },
    handleClose(done) {
      if (this.table_loading) {
        return
      }
      this.src = ""
      done()
    },
    sourceType(row) {
      if (row.source_type) {
        return row.source_type
      }
      return row.real_id || row.classify === "网络" ? "network" : "cloud"
    },
    play(row) {
      if (!row.media_url) {
        this.$message.warning('该音效暂无可用试听地址')
        return
      }
      this.src = row.media_url
    },
    async getList(resetPage = true) {
      if (!this.search_op.search_name) {
        this.$message.warning("请输入搜索关键词")
        return
      }
      if (resetPage) {
        this.page_num = 1
      }
      this.table_loading = true
      try {
        const response = await apis.searchSoundLog.searchTest({
          page_num: this.page_num,
          page_size: this.page_size,
          search_name: this.search_op.search_name
        })
        const body = response.data || {}
        if (body.code !== 1) {
          throw new Error(body.msg || "接口返回失败")
        }
        const data = body.data || {}
        this.tableList = Array.isArray(data.list) ? data.list : []
        this.jiebaList = Array.isArray(data.jieba) ? data.jieba : []
        this.total = Number(body.msg) || 0
      } catch (error) {
        this.tableList = []
        this.jiebaList = []
        this.total = 0
        this.$message.error(`获取失败：${error.message || error}`)
      } finally {
        this.table_loading = false
      }
    },
    handleSizeChange(value) {
      this.page_size = value
      this.getList(false)
    },
    handleCurrentChange(value) {
      this.page_num = value
      this.getList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 82px);
  padding: 0 24px 24px;
  overflow: auto;
  box-sizing: border-box;
}

.player {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background: #111827;

  video {
    width: 100%;
    height: 100%;
  }
}

.player-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.search-form {
  margin-top: 18px;
}

.summary {
  min-height: 32px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
  color: #606266;
}

.word-tag {
  margin-right: 6px;
}

.total {
  margin-left: auto;
  font-weight: 600;
  color: #303133;
}

.pagination {
  margin-top: 18px;
  text-align: right;
}
</style>
